import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function formatCurrency(amount: number) {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(amount);
}

export function formatDate(dateString: string) {
    return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
}
export function truncateString(str: string | null | undefined, length: number = 25) {
    if (!str) return '';
    if (str.length <= length) return str;
    return str.slice(0, length) + '...';
}

export function calculateDueDate(createdAt: string | Date, productionDays: number = 5): Date {
    const date = new Date(createdAt);
    
    const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Chicago',
        hour: 'numeric',
        hourCycle: 'h23'
    });
    
    const centralHour = parseInt(formatter.format(date), 10);
    let daysToAdd = productionDays;
    
    // If order placed at 15:00 (3 PM) or later Central Time, add 1 extra production day
    // (Treats late orders as if they were placed the next day)
    if (centralHour >= 15) {
        daysToAdd += 1;
    }
    
    while (daysToAdd > 0) {
        date.setDate(date.getDate() + 1);
        // 0 is Sunday, 6 is Saturday
        if (date.getDay() !== 0 && date.getDay() !== 6) {
            daysToAdd--;
        }
    }
    return date;
}
